import { environments } from './constants';

let navigateFn = null;

export const setNavigate = fn => {
    navigateFn = fn;
};

export const navigateTo = (path, options) => {
    if (navigateFn) {
        navigateFn(path, options);
    } else if (process.env.REACT_APP_ENV === environments.LOCAL) {
        console.warn('navigate function not initialized yet');
    }
};
